import React, { useState, useEffect, useRef } from "react";
import emailjs from '@emailjs/browser';

function ContactSection() {
    const [form, setForm] = useState({
        first: "",
        last: "",
        company: "",
        email: "",
        subject: "",
        message: "",
    });
    const [submitted, setSubmitted] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const sectionRef = useRef(null);

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    function handleSubmit(e) {
        e.preventDefault();

        // Email constants
        const emailServiceId = process.env.REACT_APP_EMAIL_SERVICE_ID
        const emailTemplateId = process.env.REACT_APP_EMAIL_TEMPLATE_ID
        const emailPublicKey = process.env.REACT_APP_EMAIL_PUBLIC_KEY

        // 1. Create a FormData object from the form
        const formData = new FormData(e.target);

        // 2. Convert it to a plain object
        const formValues = Object.fromEntries(formData.entries());

        // console.log(formValues); 
        // Output: { first: "test", last: "test", company: "test", ... }

        const payload = {
			from_name: `${formValues.first} ${formValues.last}`,
			subject: formValues.subject,
			message: formValues.message,
			reply_to: formValues.email,
		};

        console.log(payload); 
 
        emailjs.send(emailServiceId, emailTemplateId, payload, emailPublicKey).then(
			(result) => {
				console.log("SUCCESS send", result.text);
				alert("Thank you for your contacting us. Your email was sent. We will reply to you as soon as possible.");
				window.location.reload();
			},
			(error) => {
				console.log("FAILED...", error.text);
			}
		);

        setSubmitted(true);
    }

    useEffect(() => {
        const target = sectionRef.current; // capture the current ref
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setFadeIn(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) observer.unobserve(target); // use captured value
            observer.disconnect();
        };
    }, []);

    return (
        <section
            id="contact"
            ref={sectionRef}
            className={`contact-bg ${fadeIn ? "fade-in" : ""}`}
        >
            <div className="contact-grid">
                <div className="contact-left">
                    <h3>
                        CONTACT
                        <br />
                        Shift Left Services
                    </h3>
                    <div className="contact-address">
                        <div>
            We’re a fully hybrid, global team. Wherever you are, we’re right there with you.
Have a question or want to explore how Shift Left can support your QA journey?
Reach out anytime through our contact form and we’ll be glad to connect!
                        </div>
                        {/* <a className="contact-link" href="/">
                            Click Here to Find Us
                        </a> */}
                    </div>
                </div>

                <div className="contact-right">
                    <form
                        className="contact-form"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                    >
                        <div className="contact-row">
                            <input
                                type="text"
                                name="first"
                                placeholder="First Name*"
                                required
                                value={form.first}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                name="last"
                                placeholder="Last Name*"
                                required
                                value={form.last}
                                onChange={handleChange}
                            />
                        </div>
                        {/* <input
                            type="company"
                            name="company"
                            placeholder="Company*"
                            required
                            value={form.company}
                            onChange={handleChange}
                        /> */}
                        <input
                            type="email"
                            name="email"
                            placeholder="Email*"
                            required
                            value={form.email}
                            onChange={handleChange}
                        />
                        <input
                            type="text"
                            name="subject"
                            placeholder="Subject*"
                            required
                            value={form.subject}
                            onChange={handleChange}
                        />
                        <textarea
                            name="message"
                            placeholder="Message*"
                            required
                            value={form.message}
                            onChange={handleChange}
                            rows={5}
                        />
                        <button className="contact-submit" type="submit">
                            Submit
                        </button>
                        {submitted && (
                            <div className="contact-success">
                                Thank you! We'll be in touch soon.
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </section>
    );
}

export default ContactSection;
